import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * Verify admin password before sensitive operations
 * @param {string} password - The password to verify
 * @returns {Promise<boolean>} - True if valid, false otherwise
 */
export const verifyAdminPassword = async (password) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      `${API_URL}/auth/verify-password`,
      { password },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    if (response.data.valid) {
      return true;
    } else {
      toast.error('❌ ΛΑΘΟΣ ΚΩΔΙΚΟΣ ADMIN!');
      return false;
    }
  } catch (error) {
    toast.error('Σφάλμα επιβεβαίωσης κωδικού');
    return false;
  }
};

/**
 * Wrapper για delete operations με password confirmation
 * @param {Function} deleteCallback - The actual delete function
 * @param {Function} setShowPasswordModal - Function to show password modal
 * @param {Function} setPendingAction - Function to set pending action
 * @param {Object} item - The item to delete
 */
export const handleDeleteWithPassword = (deleteCallback, setShowPasswordModal, setPendingAction, item) => {
  setPendingAction({ type: 'delete', callback: deleteCallback, item });
  setShowPasswordModal(true);
};

/**
 * Wrapper για edit operations με password confirmation
 * @param {Function} editCallback - The actual edit function
 * @param {Function} setShowPasswordModal - Function to show password modal
 * @param {Function} setPendingAction - Function to set pending action
 * @param {Object} item - The item to edit
 */
export const handleEditWithPassword = (editCallback, setShowPasswordModal, setPendingAction, item) => {
  setPendingAction({ type: 'edit', callback: editCallback, item });
  setShowPasswordModal(true);
};
